export default function DepartmentLayout({
  header,
  workflow,
  summary,
  coach,
  toolbar,
  children,
  navigation,
  planner = false,
  embedded = false,
}) {
  if (planner) {
    return <div className={`planner-workspace ${embedded ? 'planner-workspace-embedded' : ''}`}>
      {navigation}
      <div className="planner-workspace-main">{header}<main className="planner-workspace-content">{children}</main></div>
    </div>;
  }
  return (
    <div
      style={{
        display: "grid",
        gap: 14,
      }}
    >
      {header}

      {workflow}

      {summary}

      {coach}

      {toolbar}

      {children}
    </div>
  );
}
